import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()

  const [roleId, setRoleId] = useState(3);
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }

  const initRole = async () => {

    let tempRole = await localStorage.getItem('roleId');
    if (tempRole) { setRoleId(tempRole); }

  }

  useEffect(() => {
    initRole();
  }, []);

  console.log(roleId);

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard" className="">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Daily Task Summary")}</span>
              </Link>
            </li>
            <li>
              <Link to="/ppmdashboard" className="">
                <i className="bx bx-calendar"></i>
                <span>{props.t("PPM Task Summary")}</span>
              </Link>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-report"></i>
                {/* <span className="badge rounded-pill bg-info float-end">
                  04
                </span> */}
                <span>{props.t("Reports")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/reports/logbook/daily" className="">
                    <span>{props.t("Daily Logbook")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/reports/logsheet/daily" className="">
                    <span>{props.t("Daily Logsheet")}</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to="/#">{props.t("Energy meters Consumption")}</Link>
                </li> */}
                {/* <li>
                  <Link to="/#">{props.t("Audit Log Report")}</Link>
                </li> */}
                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Alert")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/reports/alerts/log">{props.t("Alert Log")}</Link>
                    </li>
                    <li>
                      <Link to="/reports/alerts/summary">{props.t("Alert Summary")}</Link>
                    </li>
                    <li>
                      <Link to="/reports/alerts/trend">{props.t("Trend")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Task")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/reports/task/tasks-not-done">{props.t("Tasks not done")}</Link>
                    </li>
                    <li>
                      <Link to="/reports/task/all-sites-task-summary">{props.t("All sites task summary")}</Link>
                    </li>
                    <li>
                      <Link to="/reports/task/task-summary">{props.t("Task summary")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Verification")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/verification/summary">{props.t("Summary")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Log")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Datawise Report")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/reports/remarks-log" className="">
                    <span>{props.t("Remarks Log")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/reports/asset-status-log" className="">
                    <span>{props.t("Asset Status Log Report")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/reports/mobile-user-log" className="">
                    <span>{props.t("Mobile User Log")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/reports/unplanned-task-log" className="">
                    <span>{props.t("Unplanned Task Log")}</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to="/reports/daily-logsheet-report" className="">
                    <span>{props.t("Daily Logsheet")}</span>
                  </Link>
                </li> */}
                {/* <li>
                  <Link to="/dashboard" className="">
                    <span>{props.t("Cost Report")}</span>
                  </Link>
                </li> */}

                <li>
                  <Link to="/reports/equipment-history-card" className="">
                    <span>{props.t("Equipment History Card")}</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-report"></i>
                {/* <span className="badge rounded-pill bg-info float-end">
                  04
                </span> */}
                <span>{props.t("PPM")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                {/* <li>
                  <Link to="/rescheudule">{props.t("Rescheudule")}</Link>
                </li> */}
                {/* <li>
                  <Link to="/aprovel-log">{props.t("PPM Aprovel Log")}</Link>
                </li> */}
                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Report")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/ppm/logsheet">{props.t("Logsheet")}</Link>
                    </li>
                    {/* <li>
                      <Link to="/activity-wise">{props.t("Activity-wise")}</Link>
                    </li> */}
                  </ul>
                </li>
                <li>
                  <Link to="/ppm/calendar">{props.t("PPM Calendar")}</Link>
                </li>
                {/* <li>
                  <Link to="/current-week">{props.t("Current Week")}</Link>
                </li>
                <li>
                  <Link to="/next-week">{props.t("Next Week")}</Link>
                </li>
                <li>
                  <Link to="/cost-report">{props.t("Cost Report")}</Link>
                </li> */}
                {/* <li>
                  <Link to="/#" className="has-arrow ">{props.t("Work order")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/asset-wise">{props.t("Asset-wise")}</Link>
                    </li>
                    <li>
                      <Link to="/work-order-listing">{props.t("Work Order Listing")}</Link>
                    </li>
                  </ul>
                </li> */}
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-report"></i>
                {/* <span className="badge rounded-pill bg-info float-end">
                  04
                </span> */}
                <span>{props.t("Analytics")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/#">{props.t("Asset Comparison")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Parameter Comparison")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Task Summary Graph")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Missed Task Analysis")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-report"></i>
                {/* <span className="badge rounded-pill bg-info float-end">
                  04
                </span> */}
                <span>{props.t("Admin")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Email")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/#">{props.t("Generate")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Listing")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#">{props.t("Import Tool")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Import Contract")}</Link>
                </li>
                <li>
                  <Link to="/taskloader">{props.t("Task Loader")}</Link>
                </li>
                <li>
                  <Link to="/qr">{props.t("QR Code Generator")}</Link>
                </li>
                <li>
                  <Link to="/unplanned-task-forms">{props.t("Unplanned Task Forms")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-report"></i>
                {/* <span className="badge rounded-pill bg-info float-end">
                  04
                </span> */}
                <span>{props.t("Masters")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Asset")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/assets/new">{props.t("Add Asset")}</Link>
                    </li>
                    <li>
                      <Link to="/assets/index">{props.t("Asset Listing")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Import Asset")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Activity")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to={{ pathname: "/activities/new", query: { id: 'new' } }}>{props.t("Add Activity")}</Link>
                    </li>
                    <li>
                      <Link to="/activities/index">{props.t("Activity Listing")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">{props.t("PPM Activity")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to={{ pathname: "/ppmactivities/new", query: { id: 'new' } }}>{props.t("Add PPM Activity")}</Link>
                    </li>
                    <li>
                      <Link to="/ppmactivities/index">{props.t("PPM Activity Listing")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Properties")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/properties/new">{props.t("Add property")}</Link>
                    </li>
                    <li>
                      <Link to="/properties/index">{props.t("Property listing")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Blocks")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to={{ pathname: "/blocks/new", query: { id: 'new' } }}>{props.t("Add block")}</Link>
                    </li>
                    <li>
                      <Link to="/blocks/index">{props.t("Block listing")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Buildings")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to={{ pathname: "/buildings/new", query: { id: 'new' } }}>{props.t("Add building")}</Link>
                    </li>
                    <li>
                      <Link to="/buildings/index">{props.t("Building listing")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Floors")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/floors/new">{props.t("Add Floor")}</Link>
                    </li>
                    <li>
                      <Link to="/floors/index">{props.t("Floor Listing")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Rooms")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/rooms/new">{props.t("Add Room")}</Link>
                    </li>
                    <li>
                      <Link to="/rooms/index">{props.t("Room Listing")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Groups")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/groups/new">{props.t("Add group")}</Link>
                    </li>
                    <li>
                      <Link to="/groups/index">{props.t("Group Listing")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Users")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/employees/new">{props.t("Add Employee")}</Link>
                    </li>
                    <li>
                      <Link to="/employees/index">{props.t("Employee Listing")}</Link>
                    </li>
                    <li>
                      <Link to="/admins/index">{props.t("Admin Users")}</Link>
                    </li>
                    {/* <li>
                      <Link to="/employees/new">{props.t("Disabled Employee Listing")}</Link>
                    </li> */}
                    {/* <li>
                      <Link to="/employees/">{props.t("Employee Listing Old")}</Link>
                    </li> */}
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Asset Type")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/assettypes/new">{props.t("Add Asset Type")}</Link>
                    </li>
                    <li>
                      <Link to="/assettypes/index">{props.t("Asset Type Listing")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Vendors")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/vendors/new">{props.t("Add Vendor")}</Link>
                    </li>
                    <li>
                      <Link to="/vendors/index">{props.t("Vendor Listing")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">{props.t("Contracts")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/contracts/new">{props.t("Add Contract")}</Link>
                    </li>
                    <li>
                      <Link to="/contracts/index">{props.t("Contract Listing")}</Link>
                    </li>
                  </ul>
                </li>

                {/* <li>
                  <Link to="/#" className="has-arrow ">{props.t("Service Type")}</Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/service-type">{props.t("Service Profile Listing")}</Link>
                    </li>
                    <li>
                      <Link to="/service-type/new">{props.t("Service Profile Add")}</Link>
                    </li>

                  </ul>
                </li> */}

              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-report"></i>
                <span>{props.t("Forms")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/forms/index">{props.t("View Forms")}</Link>
                </li>
                <li>
                  <Link to="/forms/new">{props.t("Create Form")}</Link>
                </li>
              </ul>
            </li>
            {/* <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Inventory")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/#">{props.t("Vendor Listing")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Contract Listing")}</Link>
                </li>
              </ul>
            </li> */}





          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
